import { Box, Text, useColorMode } from '@chakra-ui/react';
import { withOptions } from '../code-blocks';
import CodeBlock from '../CodeBlock';
import { ProgressBar } from 'ms-react-progress-bar';
import { bgColor, borderColor } from '../const';
import { IProgressOptions } from 'ms-react-progress-bar/dist/models/models';

export const WithOptions = () => {
	const { colorMode } = useColorMode();
	const options: IProgressOptions = {
		height: '30px',
		borderRadius: '20px',
		labelSize: '14px',
		barColor: '#2c43ac',
		containerColor: '#dddddd',
		containerStyle: 'border',
		stripeAnimation: true,
		stripeAnimationDuration: '20s',
		type: 'striped'
	};
	return (
		<Box my="20px">
			<Text fontSize="2xl" fontWeight="bold" py="10px">
				Adding Options
			</Text>
			<Box>
				<CodeBlock text={withOptions} language="jsx" />
				<Box bg={bgColor[colorMode]} border="1px" borderColor={borderColor[colorMode]} borderRadius="sm">
					<Text fontSize="large" mx="10px" fontWeight="bold">
						Output
					</Text>
					<ProgressBar value={80} options={options} />
				</Box>
			</Box>
		</Box>
	);
};
